export default "<app-nav-bar></app-nav-bar>\r\n\r\n<h3>Bienvenidos a KINVA</h3>"